/**
 * Donut - card design v3.
 */
import React from "react";
import { tokensV2 as T } from "./tokens.v2";

const PALETTE = ["#FC8019", "#7C4DFF", "#4CAF50", "#FF6B9D"];

export function Donut({ title, subtitle, data = [], size = 180, thickness = 24, format = (v) => v.toLocaleString("en-IN"), centerLabel, centerValue }) {
  const total = data.reduce((s, d) => s + d.value, 0) || 1;
  const r = (size - thickness) / 2;
  const c = size / 2;
  const circumference = 2 * Math.PI * r;
  let offset = 0;
  const arcs = data.map((d, i) => {
    const len = (d.value / total) * circumference;
    const arc = {
      color: PALETTE[i % PALETTE.length],
      label: d.label, value: d.value,
      pct: (d.value / total) * 100,
      strokeDasharray: len + " " + circumference,
      strokeDashoffset: -offset,
    };
    offset += len;
    return arc;
  });

  return (
    <div style={{
      width: "100%",
      height: "100%",
      backgroundColor: T.surface.card,
      borderRadius: 16,
      padding: 16,
      borderLeft: "4px solid " + T.brand.base,
      display: "flex", flexDirection: "column", gap: 16,
      fontFamily: T.font.sans,
      boxShadow: "0 1px 2px rgba(31,42,63,0.04)",
      boxSizing: "border-box",
    }}>
      <div>
        <div style={{ fontSize: 17, fontWeight: 700, color: T.text.primary, letterSpacing: "-0.01em" }}>{title}</div>
        {subtitle && <div style={{ fontSize: 12, color: T.text.muted, marginTop: 4 }}>{subtitle}</div>}
      </div>

      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 16, flex: 1, justifyContent: "center" }}>
        <svg width={size} height={size} viewBox={"0 0 " + size + " " + size} style={{ flexShrink: 0 }}>
          <circle cx={c} cy={c} r={r} fill="none" stroke="rgba(0,0,0,0.06)" strokeWidth={thickness} />
          {arcs.map((a, i) => (
            <circle key={i} cx={c} cy={c} r={r}
              fill="none" stroke={a.color} strokeWidth={thickness}
              strokeDasharray={a.strokeDasharray}
              strokeDashoffset={a.strokeDashoffset}
              transform={"rotate(-90 " + c + " " + c + ")"}
              strokeLinecap="butt"
            />
          ))}
          <text x={c} y={c - 6} textAnchor="middle" fill={T.text.muted}
            fontSize="11" fontFamily={T.font.sans}
            style={{ textTransform: "uppercase", letterSpacing: "0.08em" }}>{centerLabel || "TOTAL"}</text>
          <text x={c} y={c + 18} textAnchor="middle" fill={T.text.primary}
            fontSize="24" fontWeight="800" fontFamily={T.font.sans}
            style={{ fontFeatureSettings: T.font.nums }}>{centerValue || format(total)}</text>
        </svg>

        <div style={{
          display: "flex", flexWrap: "wrap", justifyContent: "center",
          gap: "10px 18px", width: "100%", padding: "0 4px",
        }}>
          {arcs.map((a, i) => (
            <div key={i} style={{
              display: "flex", alignItems: "center", gap: 8,
              minWidth: 0,
            }}>
              <span style={{ width: 10, height: 10, borderRadius: 3, backgroundColor: a.color, flexShrink: 0 }} />
              <span style={{
                display: "flex", flexDirection: "column", lineHeight: 1.2,
              }}>
                <span style={{
                  fontSize: 12, fontWeight: 600, color: T.text.primary,
                  whiteSpace: "nowrap",
                }}>{a.label}</span>
                <span style={{
                  fontSize: 12, fontWeight: 700, color: T.text.primary,
                  fontVariantNumeric: "tabular-nums", fontFeatureSettings: T.font.nums,
                  whiteSpace: "nowrap",
                }}>
                  {format(a.value)}
                  <span style={{ fontWeight: 600, color: T.text.muted, marginLeft: 6 }}>
                    {a.pct.toFixed(1)}%
                  </span>
                </span>
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
